import NetworkBreadCrumbs from './NetworkBreadCrumbs';

export default NetworkBreadCrumbs;
